import { useEffect, useRef } from "react"
import * as THREE from "three"
import { useThree } from "@react-three/fiber"
import useGame from "./stores/useGame.js"

export default function MusicBG() {
  const { camera } = useThree()
  const startBgMusic = useGame((state) => state.startBgMusic)
  const space = useGame((state) => state.space)
  
  const bgRef = useRef(null)      // General background music (unchanged)
  const homeRef = useRef(null)    // Home-specific music
  const listenerRef = useRef(null)

  // Setup listener and general BG music (same as before)
  useEffect(() => {
    const listener = new THREE.AudioListener()
    listenerRef.current = listener
    camera.add(listener)

    const bgSound = new THREE.Audio(listener)
    bgRef.current = bgSound

    const loader = new THREE.AudioLoader()
    loader.load("/Music/background2.mp3", (buffer) => {
      bgSound.setBuffer(buffer)
      bgSound.setLoop(true)
      bgSound.setVolume(0.01)
      if (startBgMusic) bgSound.play()
    })

    return () => {
      if (bgRef.current?.isPlaying) bgRef.current.pause()
      if (homeRef.current?.isPlaying) homeRef.current.pause()
      camera.remove(listener)
    }
  }, [camera])

  // Handle home music separately
  useEffect(() => {
    if (!listenerRef.current) return

    // Stop previous home music if exists
    if (homeRef.current) {
      if (homeRef.current.isPlaying) homeRef.current.pause()
      homeRef.current = null
    }

    // Only load home music if in home/wall/table
    if (space === "home" || space === "wall" || space === "table") {
      const homeSound = new THREE.Audio(listenerRef.current)
      homeRef.current = homeSound
      new THREE.AudioLoader().load("/Music/home.mp3", (buffer) => {
        homeSound.setBuffer(buffer)
        homeSound.setLoop(true)
        homeSound.setVolume(0.05)
        if (startBgMusic) homeSound.play()
      })
    }
  }, [space])

  // Play/pause both sounds based on startBgMusic
  useEffect(() => {
    if (bgRef.current) {
      if (startBgMusic) {
        if (!bgRef.current.isPlaying) bgRef.current.play()
        if (homeRef.current && !homeRef.current.isPlaying) homeRef.current.play()
      } else {
        if (bgRef.current.isPlaying) bgRef.current.pause()
        if (homeRef.current?.isPlaying) homeRef.current.pause()
      }
    }
  }, [startBgMusic])

  return null
}
